import PuzzleNumberSquare from './Root.vue';
import PuzzleNumberSquareCreate from './views/PuzzleNumberSquareCreate.vue';
import PuzzleNumberSquareEdit from './views/PuzzleNumberSquareEdit.vue';
import PuzzleNumberSquareList from './views/PuzzleNumberSquareList.vue';

export default {
  path: 'gerador/number-square',
  name: 'admin-puzzle-number-square',
  component: PuzzleNumberSquare,
  redirect: '/novo',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-puzzle-number-square-list',
      component: PuzzleNumberSquareList,
    },
    {
      path: 'novo/',
      name: 'admin-puzzle-number-square-new',
      component: PuzzleNumberSquareCreate,
    },
    {
      path: ':puzzleId',
      name: 'admin-puzzle-number-square-edit',
      component: PuzzleNumberSquareEdit,
    },
  ],
};
